<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<a id="title9"></a><div class="title-toc">Table of Contents</div>
<div class="toc_entry"><span class="toc_entry_titlePage" href="#/e9781429998314_tp01" id="toctitle7" title="Link target outside of Sample"><span>Title Page</span></span><br/>
<a class="toc_entry_epigraphPage" href="#/e9781429998314_epi01" id="toctitle11"><span>Epigraph</span></a><br/>
<a class="toc_entry_frontMatter" href="#/e9781429998314_fm01" id="toctitle1"><span><strong class="b">Preface</strong> - <strong class="b">This Is How It Went</strong></span></a><br/><br/>
<a class="toc_entry_chapter" href="#/e9781429998314_c01" id="toctitle2"><span><strong class="b">Characters</strong></span></a><br/>
<a class="toc_entry_chapter" href="#/e9781429998314_c02" id="toctitle3"><span><strong class="b">Setting</strong></span></a><br/><br/>
<span class="toc_entry_aboutAuthorPage" href="#/e9781429998314_ata01" id="toctitle4" title="Link target outside of Sample"><span><strong class="b">Neil LaBute</strong> - <strong class="b">This Is How It Goes</strong></span></span><br/>
<span class="toc_entry_alsoby" href="#/e9781429998314_als01" id="toctitle5" title="Link target outside of Sample"><span><strong class="b">Other works by Neil LaBute</strong></span></span><br/>
<span class="toc_entry_praisePage" href="#/e9781429998314_pra01" id="toctitle6" title="Link target outside of Sample"><span><strong class="b">Praise for the plays of Neil LaBute</strong></span></span><br/>
<span class="toc_entry_pubInfo" href="#/e9781429998314_cop01" id="toctitle8" title="Link target outside of Sample"><span>Copyright Page</span></span><br/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429998314_toc01.vue?01513501